import React from 'react';

const Assesementpopup = () => {
  return (
    <section className="bg-[#0D2B36] text-gray-300 px-6 py-8 md:px-10 max-h-[80vh] p-4 overflow-y-auto rounded-lg">
      <div className="max-w-5xl mx-auto space-y-4 text-white">
        <p>
          Ethosflo’s assessment is built on a globally recognized set of sustainability regulations and standards:
        </p>

        <ul className="list-disc list-outside p-4 text-justify  space-y-4 text-base">
          <li classNasme="mr-6">
            <span className="font-semibold text-green-400">India:</span> Business Responsibility and Sustainability Reporting (BRSR)
          </li>
          <li>
            <span className="font-semibold text-green-400">European Union (EU):</span> EU Forced Labor Ban, Corporate Sustainability Due Diligence Directive (CSDDD), EU Taxonomy, Corporate Sustainability Reporting Directive (CSRD), German Supply Chain Due Diligence Act (LkSG), Norway Transparency Act, Uyghur Forced Labor Prevention Act (UFLPA), Carbon Border Adjustment Mechanism (CBAM), Devoir de Vigilance (Duty of Care Law), Dutch Child Labor Due Diligence Law, Sustainable Finance Disclosure Regulation (SFDR)
          </li>
          <li>
            <span className="font-semibold text-green-400">United Kingdom (UK):</span> UK Modern Slavery Act
          </li>
          <li>
            <span className="font-semibold text-green-400">Canada:</span> Net-Zero Emissions Accountability Act (C-12 Bill), Modern Slavery Act (S-211)
          </li>
          <li>
            <span className="font-semibold text-green-400">Australia:</span> Climate-Related Financial Disclosure (CRFD), Modern Slavery Act (Commonwealth Act)
          </li>
          <li>
            <span className="font-semibold text-green-400">United States (USA):</span> California Transparency Act (CTSCA), California Transparency in Supply Chains Act SB 657, California Climate-Related Financial Risk Acts (SB 261 and SB 219), California Climate Corporate Data Accountability Act (SB 253), SEC’s Climate Risk Disclosure Rule
          </li>
          <li>
            <span className="font-semibold text-green-400">International Standards:</span> ISO 9001, ISO 26001, ISO 14001, Organization for Economic Co-operation and Development (OECD), United Nations Global Compact (UNGC)
          </li>
          <li>
            <span className="font-semibold text-green-400">Reporting Frameworks:</span> Global Reporting Initiative (GRI), European Sustainability Reporting Standards (ESRS), Integrated Reporting Framework (IIRC)
          </li>
        </ul>
      </div>
    </section>
  );
};

export default Assesementpopup;